<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0" id="toClick">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content>
    <div
      class="main_div"
      *ngIf="entitySubscriptionHistoryData.length > 0 && toShowExistingPlans"
    >
      <div class="main_div_sub_div">
        <div
          class="business_subs"
          *ngFor="let item of entitySubscriptionHistoryData"
        >
          <h3>{{ item.planName }}</h3>
          <p>{{ item.planDescription }}</p>
          <span>Purchased on:</span>
          <p>{{ item.creationDate | date }}</p>
          <span>Validity:</span>
          <p>{{ item.validity }} days</p>
          <div class="btn-cont">
            <button
              mat-flat-button
              (click)="createBusinessWithExistingSubs(item)"
            >
              Select Pack
            </button>
          </div>
        </div>
        <div class="add_new_btn">
          <button mat-flat-button color="accent" (click)="addNewSubs()">
            Add New Pack
          </button>
        </div>
      </div>
    </div>
  
    <div class="plans_div" *ngIf="plansList.length > 0 && toShowPlatformPlans">
      <div class="plans_sub_div" *ngFor="let item of plansList">
        <div
          class="platform_subs"
          (click)="onSelectPlan(item)"
          [ngClass]="{ make_grey_bg: item.isExpired == 1 }"
        >
          <h1>{{ item.title }}</h1>
          <mat-icon class="mat-18" [ngClass]="{ selected: item.selected == true }"
            >check_circle</mat-icon
          >
          <h1 style="font-size: 3rem; font-weight: 500; margin: 23px 0">
            Rs. {{ item.perUnitCost }}
          </h1>
          <h2 style="margin-bottom: 5px">{{ item.validity }} validity</h2>
          <h3 style="margin: 0">{{ item.description }}</h3>
        </div>
      </div>
    </div>
  
    <div class="business_form" *ngIf="toShowForm">
      <div class="business_form_sub_div">
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput #input [(ngModel)]="newBusinessObj.name" />
          </mat-form-field>
        </div>
        <section class="example-section">
          <mat-checkbox
            class="example-margin"
            value="Salon"
            (change)="clickTypeCheckbox($event)"
            [checked]="tochecksalon"
            >Salon</mat-checkbox
          >
        </section>
        <section class="example-section">
          <mat-checkbox
            class="example-margin"
            value="Beauty Parlour"
            (change)="clickTypeCheckbox($event)"
            [checked]="tocheckbeautyparlour"
            >Beauty Parlour</mat-checkbox
          >
        </section>
        <section class="example-section">
          <mat-checkbox
            class="example-margin"
            value="Spa"
            (change)="clickTypeCheckbox($event)"
            [checked]="tocheckspa"
            >Spa</mat-checkbox
          >
        </section>
        <section class="example-section" style="margin-bottom: 10px">
          <mat-checkbox
            class="example-margin"
            value="Makeup Artist"
            (change)="clickTypeCheckbox($event)"
            [checked]="tocheckmakeup"
            >Make-up Artist</mat-checkbox
          >
        </section>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Address</mat-label>
            <input
              [(ngModel)]="newBusinessObj.addressInfo.addressLine"
              matInput
              (input)="updateSearchResults()"
              [matAutocomplete]="auto"
            />
            <mat-icon matSuffix class="material-icons-outlined"
              >person_pin_circle</mat-icon
            >
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let item of autocompleteItems"
                (click)="selectSearchResult(item)"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
  
          <!-- <mat-form-field appearance="outline">
              <mat-label>Address</mat-label>
              <input matInput #input [(ngModel)]="newBusinessObj.addressInfo.addressLine"/>
            </mat-form-field> -->
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea
              matInput
              #input
              [(ngModel)]="newBusinessObj.entityDesc"
            ></textarea>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input matInput #input [(ngModel)]="newBusinessObj.phone" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Owner Name</mat-label>
            <input matInput #input [(ngModel)]="newBusinessObj.ownerName" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Owner Phone Number</mat-label>
            <input matInput #input [(ngModel)]="newBusinessObj.ownerPhone" />
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Registration Number</mat-label>
            <input matInput #input [(ngModel)]="newBusinessObj.referenceNo" />
          </mat-form-field>
        </div>
        <!-- <section class="example-section" *ngIf="!editmode">
          <mat-checkbox
            class="example-margin"
            (change)="clickAvailabilityCheckbox($event)"
            >Service Available Now</mat-checkbox
          >
        </section> -->
        <section class="example-section" >
          <mat-checkbox
            class="example-margin"
            (change)="clickServiceAvailabilityCheckbox($event,1)"
            [checked]="shopServiceAvailable"
            >Shop Service Available</mat-checkbox
          >
        </section>
        <section class="example-section" >
          <mat-checkbox
            class="example-margin"
            (change)="clickServiceAvailabilityCheckbox($event,0)"
            [checked]="homeServiceAvailable"
            >Home Service Available</mat-checkbox
          >
        </section>
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" *ngIf="toShowForm">
    <button mat-button (click)="goBack()">Back</button>
    <button mat-flat-button color="accent" (click)="onSubmit()">{{editmode ? 'Edit' : 'Create'}}</button>
  </mat-dialog-actions>
  <mat-dialog-actions align="end" *ngIf="toShowPlatformPlans">
    <div style="position: relative; left: -80px; top: 3px" *ngIf="toShowMonths">
      <span style="position: relative; top: -8px; margin-right: 10px"
        >No. of Months</span
      >
      <button
        (click)="changeNoOfMonths(0)"
        style="
          border: none;
          background: #fff;
          position: relative;
          top: -2px;
          font-size: 22px;
        "
        [disabled]="noOfMonths == 1"
        
      >
        <mat-icon
          class="material-icons-round try"
          [ngStyle]="{'color': noOfMonths == 1 ? 'lightgray' : '#ffbf00'}"
          [inline]="true"
          >do_not_disturb_on</mat-icon
        >
      </button>
      <input type="text" [(ngModel)]="noOfMonths" style="width: 30px!important;
      height: 30px!important;
      border: none;
      padding: 0;
      text-align: center;
      background: #fff;
      position: relative;
      top: -8px;
  ">
      <button
        (click)="changeNoOfMonths(1)"
        style="
          border: none;
          background: #fff;
          position: relative;
          top: -2px;
          font-size: 22px;
        "
      >
        <mat-icon
          class="material-icons-round try"
          style="color: #ffbf00"
          [inline]="true"
          >add_circle</mat-icon
        >
      </button>
    </div>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent" (click)="onContinue()">
      Continue
    </button>
  </mat-dialog-actions>
  